import { memo } from 'react';
import type { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Hamburger as HamburgerIcon } from '@vgno/icons';

import { useOverlay } from '../../Overlay/useOverlay';
import { NamedIcon } from '../../Icon/Icon';
import { Overlay } from '../../Overlay/Overlay';
import { getPath, routeNames } from '../../../shared/helpers/routes';
import { config } from '../../../config';
import { getHomepageSlug } from '../../../shared/helpers/getHomepageSlug';
import { trackNavigationClick } from '../../../shared/helpers/trackingHelpers';
import { OverlayMenu } from '../../OverlayMenu/OverlayMenu';
import type { MainMenuItem, MenuItem } from '../helpers';

import * as styles from './MobileNavigation.module.scss';

interface MobileNavigationProps {
  mainMenuItems: MainMenuItem[];
  subMenuItems: MenuItem[];
}

const MobileNavigationBase: FC<MobileNavigationProps> = ({
  mainMenuItems,
  subMenuItems,
}) => {
  const { t } = useTranslation();
  const { isOpen, open, close, ariaAttributes } = useOverlay();

  return (
    <nav className={styles.container}>
      <ul className={styles.menu}>
        {mainMenuItems.map(({ label, link, iconName, id, type }, index) => (
          <li key={index}>
            <Link
              to={link!}
              className={styles.menuItemContent}
              onClick={() =>
                trackNavigationClick({
                  label,
                  link,
                  id,
                  type,
                })
              }
            >
              <NamedIcon name={iconName} />
              <span className={styles.menuItemLabel}>{label}</span>
            </Link>
          </li>
        ))}
        <li>
          <button
            onClick={open}
            className={styles.menuItemContent}
            {...ariaAttributes}
          >
            <HamburgerIcon />
            <span className={styles.menuItemLabel}>{t('More')}</span>
          </button>
        </li>
      </ul>
      <Overlay type="overlay/drawer" onCloseButtonClick={close} isOpen={isOpen}>
        <OverlayMenu
          items={[
            {
              link: getPath(routeNames.custom, {
                slug: getHomepageSlug(config.provider),
              }),
              label: t('Home'),
              id: 'hjem',
            },
            ...subMenuItems,
          ]}
          onItemClick={close}
        />
      </Overlay>
    </nav>
  );
};

export const MobileNavigation = memo(MobileNavigationBase);
